import log from 'loglevel'
import { PlotCompositeLayer } from '@/js/custom-layers/PlotCompositeLayer.js'
import { DataFilterExtension } from '@deck.gl/extensions'

// レイヤーID
const LAYER_ID = 'plot'

/**
 * プロットのレンダラー
 */
class PlotRenderer {
  /**
   * レイヤーID
   * @returns {String}
   */
  static LAYER_ID() {
    return LAYER_ID
  }

  /**
   * コンストラクタ
   */
  constructor() {}

  /**
   * レンダラー関数を作成する
   * @param {Object|Function} data 描画するデータ
   * @param {Object} props 追加・上書きprops
   * @returns {Object} レンダラー {id: String, render: Function.<ScatterplotLayer>}
   */
  createRenderer(data, props) {
    log.debug('PlotRenderer create', data, props)
    return {
      id: LAYER_ID,
      render: () =>
        new PlotCompositeLayer({
          id: LAYER_ID,
          data: typeof data === 'function' ? data() : data,
          getPosition: (d) => d.coordinates,
          radiusUnits: 'pixels',
          getRadius: 1,
          extensions: [new DataFilterExtension({ filterSize: 1 })],
          parameters: {
            blend: true,
            depthRange: [0, 0.89],
            depthTest: false,
          },
          ...props,
        }),
    }
  }
}

PlotRenderer.LAYER_ID = LAYER_ID

export default PlotRenderer
